<!--  -->
<template>
    <div class="noticeContainer">
        <div v-html="details">
            
        </div>
    </div>
</template>
<script>
export default {
    name:"notice",
    data() {
        return {
            details:""
        }
    },
    created() {},
    mounted() {
        this.details=this.$route.query.message
        
    }
}
</script>
<style scoped lang="scss">
    .noticeContainer{
        width: 100%;
        height: 100%;
        background: #eee;
        >div{
            width: 100%;
            height: auto;
            background: #fff;
            padding: 20px;
            box-sizing: border-box;
            /deep/ p{
                font-size: 16px !important;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/notice.vue